import { render, staticRenderFns } from "./ClasificacionArtistasPorOyentes.vue?vue&type=template&id=8bda7424&"
import script from "./ClasificacionArtistasPorOyentes.vue?vue&type=script&lang=js&"
export * from "./ClasificacionArtistasPorOyentes.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionArtistasPorOyentes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports